<template>
    <div class="allchain">
        <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="项目评估"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>

            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span class="title current">项目评估</span>
                    </div>
                </div>
                <div class="whitebox p-4">
                    <div class="boxcontent">
                        <div class="project">
                            <el-form ref="projectForm" :model="project" :rules="rules" label-position="left"
                                label-width="120px" class="employer-ruleForm">
                                <!-- 项目附件上传 -->
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label="项目附件" prop="fileList" required>
                                            <el-upload class="upload-demo fl" action="#" :http-request="uploadFileList"
                                                :on-preview="handlePreview" :on-remove="handleRemove"
                                                :on-success="handleAvatarSuccess" :on-exceed="handleExceed"
                                                :before-remove="beforeRemove" :limit="4" multiple
                                                :file-list="project.projectFileList"
                                                :show-file-list="project.showFileList"
                                                accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
                                                <el-button size="small" type="primary"
                                                    :disabled="isDisabled">点击上传</el-button>
                                            </el-upload>
                                            <div class="el-upload__tip"
                                                style="clear: both; color: #999; font-size: 12px;">
                                                仅支持上传 Word、PDF、Excel、PPT格式，且单个文件大小不超过 30MB
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="ml-3">
                                        <p>项目评估操作指南</p>
                                        <p>1.点击上传项目文件（Word/PDF/Excel/PPT，≤30MB）；</p>
                                        <p>2.系统自动提取内容、评估完整性（约5-10分钟）；</p>
                                        <p>3.资料完整后点击"进行大模型自动评估"（不完整需补足后重传）；</p>
                                        <p>4.约5-10分钟后查看或下载《招商引资报告》。</p>
                                    </el-col>
                                </el-row>

                                <!-- 成对展示的字段：配置化渲染，避免模板重复 -->
                                <!-- <el-row v-for="(pair, rowIndex) in projectFieldRows" :key="rowIndex">
                                    <el-col v-for="(field, colIndex) in pair" :key="field.prop" :span="10"
                                        :offset="colIndex === 1 ? 3 : 0">
                                        <el-form-item :label="field.label" :prop="field.prop">
                                            <el-cascader v-if="field.type === 'cascader'" style="width: 100%;"
                                                v-model="project[field.prop]" :options="field.options"
                                                :disabled="isDisabled">
                                            </el-cascader>
                                            <template v-else>
                                                <div class="fl mr-1">
                                                    <el-input v-model="project[field.prop]"
                                                        :disabled="isDisabled"></el-input>
                                                </div>
                                                <template v-if="field.unit">{{ field.unit }}</template>
</template>
</el-form-item>
</el-col>
</el-row> -->
                            </el-form>

                            <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
                                <tr>
                                    <th>序号</th>
                                    <th>名称</th>
                                    <th>评估状态</th>
                                    <th>项目状态</th>
                                    <th>完整性评估</th>
                                    <th>大模型评估</th>
                                </tr>
                                <tr :key="index" v-for="(list, index) in fileList">
                                    <td>{{ (page - 1) * pageSize + index + 1 }}</td>
                                    <td>{{ list.title }}</td>
                                    <td>{{ list.assessmentStatusText }}</td>
                                    <td>{{ list.fileStatusText }}</td>
                                    <td class="cur-pointer bluefont" @click="initEvaluation(list)"> <i
                                            class="el-icon-loading"
                                            v-show="completenesLoading && list.id == activeFileId"></i> {{
                                                list.hasCompleteness ? '查看' : '进行' }}项目完整性评估</td>
                                    <td class="cur-pointer bluefont" @click="assessmentFun(list)"> <i
                                            class="el-icon-loading" v-show="aiLoading && list.id == activeFileId"></i>
                                        {{
                                            list.assessmentStatus > 1 ? '查看' : '进行' }}大模型自动评估</td>
                                </tr>
                            </table>

                            <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                                <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                                    v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                            </div>

                            <!-- 评估报告弹窗：项目信息完整性评估 / 招商引资评估报告 -->
                            <el-dialog class="localChain" custom-class="initiate_box_dialog white-bg"
                                :title="dialogTitle" center :visible.sync="isInitiate" top="">
                                <div class="my-4" v-show="dialogTitle == '项目信息完整性评估'">
                                    <el-row class="mb-1">
                                        <el-col :span="24">
                                            <div><span class="font-weight font-16">项目名称：</span>{{ completenessData.title
                                            }}</div>
                                        </el-col>
                                    </el-row>
                                    <el-row class="mb-1">
                                        <el-col :span="12">
                                            <div><span class="font-weight font-16">企业名称：</span>{{
                                                completenessData.enterpriseName }}</div>
                                        </el-col>
                                    </el-row>
                                    <el-row class="mb-1">
                                        <el-col :span="12">
                                            <div><span class="font-weight font-16">投资总额：</span>{{
                                                completenessData.amountText }}</div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div><span class="font-weight font-16">预计利润：</span>{{
                                                completenessData.profit }}</div>
                                        </el-col>
                                    </el-row>
                                    <el-row class="mb-1">
                                        <el-col :span="12">
                                            <div><span class="font-weight font-16">预计年产值：</span>{{
                                                completenessData.outputValue }}</div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div><span class="font-weight font-16">税收：</span>{{
                                                completenessData.taxation }}</div>
                                        </el-col>
                                    </el-row>
                                    <el-row class="mb-1">
                                        <el-col :span="24">
                                            <div><span class="font-weight font-16">简介：</span>{{ completenessData.summary
                                            }}</div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <el-row class="mb-1" v-show="dialogTitle == '招商引资评估报告'">
                                    <el-col :span="24">
                                        <div class="mb-3">
                                            <el-steps :active="aiEvaStep" finish-status="success" align-center>
                                                <el-step v-for="(item, i) in aiEvaStepList" :key="i"
                                                    :title="item"></el-step>
                                            </el-steps>
                                        </div>
                                    </el-col>
                                    <el-col :span="24" class="mb-2">
                                        <vue-markdown :source="completenessData.content" />
                                    </el-col>
                                    <div class="text-center">
                                        <el-button type="primary"
                                            @click="downloadReport(completenessData.id)">下载招商引资报告</el-button>

                                        <el-button type="warning" :loading="aiLoading"
                                            @click="assessmentFun(completenessData, 1)">重新进行大模型自动评估</el-button>
                                    </div>
                                </el-row>
                                <el-row class="mb-1" v-show="dialogTitle == '项目信息完整性评估'">
                                    <el-col :span="24" class="mb-2">
                                        <vue-markdown
                                            :source="completenessData.completeness || completenessData.content || ''" />
                                        <div class="text-center">
                                            <el-button type="warning" :loading="completenesLoading"
                                                @click="initEvaluation(completenessData, 1)">重新进行项目完整性评估</el-button>

                                        </div>
                                    </el-col>
                                </el-row>
                            </el-dialog>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import VueMarkdown from 'vue-markdown'
import { mapState, mapMutations, mapGetters } from "vuex";
import {downloadBlob,getTimestamp} from '@/utils/index.js';
/** 初始项目数据工厂：data 与 resetForm 共用同一份定义，避免漏改 */
function createInitialProject() {
    return {
        name: '',
        summary: '',
        showFileList: true,
        status: '',
        investorName: '',
        industryType: [],
        investmentAmount: '',
        expectedAnnualOutput: '',
        expectedProfit: '',
        expectedEmployment: '',
        demand: '',
        policy: '',
        projectFileList: [],
        fileList: [],
        customerName: '',
        taxation: '',
    };
}
export default {
    name: 'allchain',
    components: {
        VueMarkdown,
    },
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse']),

        /** 项目字段配置（成对两行布局） */
        projectFieldRows() {
            return [
                [
                    { label: '项目名称', prop: 'name' },
                    { label: '产业类型', prop: 'industryType', type: 'cascader', options: this.industryTypeOptions },
                ],
                [
                    { label: '投资方名称', prop: 'investorName' },
                    { label: '预计年产值', prop: 'expectedAnnualOutput', unit: '亿元' },
                ],
                [
                    { label: '投资总额', prop: 'investmentAmount', unit: '亿元' },
                    { label: '预计就业人数', prop: 'expectedEmployment', unit: '人' },
                ],
                [
                    { label: '预计利润', prop: 'expectedProfit', unit: '亿元' },
                ],
                [
                    { label: '税收', prop: 'taxation', unit: '亿元' },
                ],
            ];
        },

    },
    data() {
        return {
            title: "项目评估",
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            yj_mkcode: 'E-XMPG',
            yj_itemcode: 'E-XMPG',
            page: 1, // 当前页码
            pageSize: 10, // 每页条数
            total: 0, // 记录总数
            totalPage: 1, // 总页数
            maxPage: 10, // 最大页数
            project: createInitialProject(),
            loadingAddBtn: false,
            isDisabled: false,
            industryTypeOptions: [],
            userdata: {},
            fileList: [],
            rules: {
                name: [{ required: false, message: '请输入项目名称', trigger: 'blur' }],
                industryType: [{ type: 'array', required: false, message: '请选择产业类型', trigger: 'change' }],
                investorName: [{ required: false, message: '请输入投资人名称', trigger: 'blur' }],
                investmentAmount: [{ required: false, message: '请输入投资总额', trigger: 'blur' }],
                expectedAnnualOutput: [{ required: false, message: '请输入预计年产值', trigger: 'blur' }],
                summary: [{ required: false, message: '请输入项目简介', trigger: 'blur' }],
            },
            isInitiate: false,
            dialogTitle: '项目信息完整性评估',
            completenessData: {},
            completenesLoading: false,
            aiLoading: false,
            activeFileId: '',
            aiEvaStep: 1,
            aiEvaStepList: ['项目基础评估', '企业或发起人实力评估', '信息整合并生成报告', '评估完成'],
        }
    },
    watch: {
        type: {
            immediate: true,
            handler(newVal) {
                // 详情页默认只读；新增/编辑态可写
                this.isDisabled = newVal === 2;
            },
        },
        projectData: {
            immediate: true,
            handler(newVal) {
                if (newVal && Object.keys(newVal).length) {
                    this.getFileList();
                }
            },
        },
    },
    created() {
        this.userdata = this.getuseriformation();
        this.getProjectClass();
        this.getFileList();
    },
    mounted() { },
    methods: {
        // 报告下载
        async downloadReport(id) {
            const ajaxUrl = this.$api.crm.FileAssessment.Download();
            const dataParams = new FormData(); // ??必须使用 FormData 封装参数后台才能拿到不知道为什么
            dataParams.append('id', id);
            try {
                const response = await this.$axios({
                    url: ajaxUrl,
                    method: 'POST',
                    data: dataParams,
                    responseType: 'blob',        // 关键：指定响应类型为 blob
                    timeout: 60000,            // 导出可能较慢，设长一点
                    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                });

                console.log('导出数据', response);
                // 从响应头获取文件名（后端设置 Content-Disposition）
                const headers = response.headers || {}

                // 取文件名
                const dateStr = getTimestamp();
                let filename = `招商引资项目评估报告​_${dateStr}.docx`;

                downloadBlob(response.data, filename);
                this.exportDataLoading = false;
            } catch (error) {
                console.error('导出失败', error);
                this.$message.error('导出失败，请重试');
            }
        },
        /* ---------- 项目文件上传 ---------- */
        async uploadFileList(file) {
            try {
                const formData = new FormData();
                formData.append('file', file.file);
                const response = await this.$axios.post(this.$api.crm.FileAssessment.Upload(), formData, {
                    headers: {
                        AuthToken: this.userdata.token,
                        'Content-Type': 'multipart/form-data',
                    },
                    // 上传进度监听，驱动 el-upload 进度条
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.lengthComputable) {
                            const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            file.onProgress && file.onProgress({ percent: percent });
                        }
                    },
                });
                if (response.data.success) {
                    file.onSuccess && file.onSuccess(response.data);
                    this.$message.success('上传成功！');
                    // 上传成功后刷新服务端文件列表
                    this.getFileList();
                } else {
                    file.onError && file.onError(new Error(response.data.msg || '上传失败'));
                    this.$message.error(response.data.msg || '上传失败');
                }
            } catch (error) {
                console.error('上传错误:', error);
                file.onError && file.onError(error);
                this.$message.error('上传失败，请稍后重试');
            }
        },

        /** 项目文件列表 */
        async getFileList() {
            try {
                const res = await this.$axios.get(
                    this.$api.crm.FileAssessment.List() + '?page=' + this.page,
                    { headers: { AuthToken: this.userdata.token } }
                );
                if (res.data.success) {
                    this.fileList = res.data.list || [];
                    this.total = res.data.total || 0;
                    this.totalPage = Math.ceil(this.total / this.pageSize) || 1;
                }
            } catch (error) {
                console.error('获取项目文件列表失败:', error);
            }
        },

        /* ---------- 项目文件完整性评估 ---------- */
        initEvaluation(list, redo) {
            // 已评估过则查看详情，否则触发评估
            if (list.hasCompleteness && !redo) {
                this.completenessDetail(list.id);
            } else {
                this.completeness(list.id, redo);
            }
        },
        async completenessDetail(id) {
            this.activeFileId = id;
            try {
                const res = await this.$axios.get(
                    this.$api.crm.FileAssessment.Detail() + '?id=' + id,
                    { headers: { AuthToken: this.userdata.token } }
                );
                if (res.data.success) {
                    this.completenessData = res.data.data || {};
                    this.dialogTitle = '项目信息完整性评估';
                    this.isInitiate = true;
                }
            } catch (error) {
                console.error('获取评估详情失败:', error);
            }
        },
        async completeness(id, redo) {
            this.activeFileId = id;
            this.completenesLoading = true;
            try {
                const isRedo = this.splicing('redo', redo);
                const res = await this.$axios.get(
                    this.$api.crm.FileAssessment.Completeness() + '?id=' + id + isRedo,
                    { headers: { AuthToken: this.userdata.token } }
                );
                if (res.data.success) {
                    // this.completenessData = res.data.data || {};
                    // this.dialogTitle = '项目信息完整性评估';
                    // this.isInitiate = true;
                    this.completenessDetail(id);
                } else {
                    this.$message.error(res.data.msg);
                }
            } catch (error) {
                console.error('评估请求失败:', error);
                this.$message.error('评估请求失败，请稍后重试');
            } finally {
                this.completenesLoading = false;
            }
        },

        /* ---------- 招商引资大模型自动评估 ---------- */
        assessmentFun(list, redo) {
            // if (list.score < 50 && list.fileStatusText == '已完成完整性评估') {
            //     this.$message.error('分数低于50分，项目信息不完整，请完善项目信息再进行评估！');
            //     return;
            // }
            // 已评估过则查看报告，否则触发评估
            if (list.assessmentStatus > 1) {
                this.aiAutoAssessmentDetail(list.id);
            } else {
                this.aiEvaluation(list.id, redo);
            }
        },
        async aiAutoAssessmentDetail(id) {
            this.aiLoading = true;
            this.activeFileId = id;
            try {
                const res = await this.$axios.get(
                    this.$api.crm.FileAssessment.AutoAssessmentDetail() + '?id=' + id,
                    { headers: { AuthToken: this.userdata.token } }
                );
                if (res.data.success) {
                    this.completenessData = res.data.data || {};
                    this.aiEvaStep = res.data.data.status || 1;

                    // this.aiEvaStepList = res.data.data.stepList || [];
                    this.dialogTitle = '招商引资评估报告';
                    this.isInitiate = true;
                } else {
                    this.$message.error(res.data.msg);
                }
            } catch (error) {
                console.error('大模型评估请求失败:', error);
                this.$message.error('大模型评估请求失败，请稍后重试');
            } finally {
                this.aiLoading = false;
            }
        },
        async aiEvaluation(id, redo) {
            this.aiLoading = true;
            this.activeFileId = id;
            try {
                const isRedo = this.splicing('redo', redo);
                const res = await this.$axios.get(
                    this.$api.crm.FileAssessment.AutoAssessment() + '?id=' + id + isRedo,
                    { headers: { AuthToken: this.userdata.token } }
                );
                if (res.data.success) {
                    this.completenessData = res.data.data || {};
                    this.aiEvaStep = res.data.data.status || 1;
                    if (this.aiEvaStep == 4) {
                        this.getFileList();
                    }
                    // this.aiEvaStepList = res.data.data.stepList || [];
                    this.dialogTitle = '招商引资评估报告';
                    this.isInitiate = true;
                } else {
                    this.$message.error(res.data.msg);
                }
            } catch (error) {
                console.error('大模型评估请求失败:', error);
                this.$message.error('大模型评估请求失败，请稍后重试');
            } finally {
                this.aiLoading = false;
            }
        },

        /* ---------- 下拉数据 ---------- */
        async getProjectClass() {
            try {
                const res = await this.$axios.get(this.$api.tag.notion.list() + '?level=3', {
                    headers: { AuthToken: this.userdata.token },
                });
                if (res.data.success) {
                    const datalist = (res.data.list || []).filter(list => list.label.indexOf('未来') < 0);
                    this.industryTypeOptions = this.setIsIntegration(datalist);
                }
            } catch (error) {
                console.error('获取产业类型失败:', error);
            }
        },
        setIsIntegration(notionArray) {
            const tempData = { label: '传统产业', value: 'DEF', parentList: ['DEF'], children: [] };
            const newTree = [];
            notionArray.forEach(item => {
                if (item.label === '第一产业' || item.label === '第二产业' || item.label === '第三产业') {
                    tempData.children.push(item);
                    newTree[0] = tempData;
                }
                if (item.label === '先进制造业') {
                    newTree[1] = { ...item, label: '战略性新兴产业' };
                }
                if (item.label === '未来产业') {
                    newTree[2] = item;
                }
            });
            return newTree;
        },

        /* ---------- 附件 ---------- */
        handleRemove(file, fileList) {
            this.deleteFile(file.fileId)
                .then(ok => {
                    if (ok) this.project.projectFileList = fileList;
                })
                .catch(() => { /* 删除失败，保留文件列表不变 */ });
        },
        handlePreview(file) {
            // 有在线地址直接打开；否则走下载接口
            if (file.url) {
                window.open(file.url, '_blank');
            } else if (file.fileId) {
                window.open(this.$api.crm.FileAssessment.Download() + '?fileId=' + file.fileId, '_blank');
            }
        },
        handleAvatarSuccess(res, file, fileList) {
            this.project.fileList = fileList;
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        /** 删除附件：新增态本地删除不请求后端 */
        deleteFile(id) {
            return new Promise((resolve, reject) => {
                if (this.type === 1) {
                    resolve(true);
                    return;
                }
                if (!id) {
                    this.$message.warning('文件尚未保存到服务器，无需删除');
                    resolve(true);
                    return;
                }
                const formData = new FormData();
                formData.append('fileId', id);
                this.$axios.post(this.$api.crm.customer.deleteFile(), formData, {
                    headers: { AuthToken: this.userdata.token },
                }).then(res => {
                    if (res.data.success) {
                        this.$message.success('删除成功！');
                        resolve(true);
                    } else {
                        this.$message.error(res.data.msg);
                        reject(false);
                    }
                }).catch(err => {
                    console.error('删除文件失败:', err);
                    this.$message.error('删除失败，请稍后重试');
                    reject(false);
                });
            });
        },

        /* ---------- 提交 ---------- */
        postCusInfo() {
            this.$refs.projectForm.validate(valid => {
                if (!valid) {
                    this.$message.error('请填写完整的项目信息');
                    return;
                }
                if (this.isDisabled) {
                    this.$message.warning('当前为只读状态，请先点击"编辑"');
                    return;
                }
                this.loadingAddBtn = true;
                const formData = new FormData();
                formData.append('customerId', this.cusid === '' ? 0 : this.cusid);
                formData.append('project', this.project.name);
                formData.append('summary', this.project.summary);
                // 产业类型兜底，避免 append('xxx', undefined) 变成字符串 "undefined"
                const [bigClass = '', smallClass = ''] = this.project.industryType || [];
                formData.append('bigClass', bigClass);
                formData.append('smallClass', smallClass);
                formData.append('status', this.project.status);
                formData.append('amount', this.project.investmentAmount);
                formData.append('outputValue', this.project.expectedAnnualOutput);
                formData.append('profit', this.project.expectedProfit);
                formData.append('employment', this.project.expectedEmployment);
                formData.append('landing', this.project.demand);
                formData.append('policy', this.project.policy);
                formData.append('investor', this.project.investorName);
                formData.append('customerName', this.project.customerName);
                formData.append('taxation', this.project.taxation);

                this.$axios.post(this.$api.crm.project.Post(), formData, {
                    headers: { AuthToken: this.userdata.token },
                }).then(res => {
                    if (res.data.success) {
                        this.$message.success('项目添加成功!');
                        // 保存成功后刷新文件列表，让附件与项目关联
                        this.getFileList();
                    } else {
                        this.$message.error('添加失败：' + res.data.msg);
                    }
                }).catch(err => {
                    console.error('上传失败:', err);
                    this.$message.error('上传失败，请稍后重试');
                }).finally(() => {
                    this.loadingAddBtn = false;
                });
            });
        },

        /** 翻页：更新页码后重新拉取列表 */
        pageHandler(page) {
            this.page = page;
            this.getFileList();
        },

        /* ---------- 编辑/取消/重置 ---------- */
        cancelEdit() {
            this.isDisabled = true;
            this.getFileList();
        },
        resetForm() {
            this.$refs.projectForm && this.$refs.projectForm.resetFields();
            this.project = createInitialProject();
        },
    },
}
</script>

<style></style>